export function datePicker(that, ths, trs) {
  return [
    {
      h: 'div', c: 'date-picker',
      z: [
        {
          h: 'div', c: 'action-header',
          z: [
            {
              h: 'div', c: 'action-item-left', html: '«',
              event: (ev) => {
                that.selectFirst(ev);
              }
            },
            {
              h: 'div', c: 'action-item-left', html: '‹',
              event: (ev) => {
                that.selectFirstMonth(ev);
              }
            },
            {
              h: 'div', c: 'action-item-content', html: `${that.value.year}年 ${that.value.month}月`,
              event: (ev) => {
                ev.stopPropagation();
              }
            },
            {
              h: 'div', c: 'action-item-right', html: '›',
              event: (ev) => {
                that.selectLastMonth(ev);
              }
            },
            {
              h: 'div', c: 'action-item-right', html: '»',
              event: (ev) => {
                that.selectLast(ev);
              }
            }
          ]
        },
        {
          h: 'div', c: 'action-mian',
          z: [
            {
              h: 'table', c: 'date-panel',
              z: [
                {
                  h: 'thead', c: '',
                  z: ths
                },
                {
                  h: 'tbody', c: '',
                  z: trs
                }
              ]
            }
          ]
        },
        {
          h: 'div', c: 'action-footer',
          z: [
            {
              h: 'div', c: 'action-item center', e: [{
                t: 'click', e: (ev) => {
                  ev.stopPropagation();
                }
              }],
              z: [
                {
                  h: 'span', c: 'item-list', html: '今天',
                  event: (ev) => {
                    that.selectThatDay(ev);
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ];
}